'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getParents = require('./get-parents');

var _getParents2 = _interopRequireDefault(_getParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLevel = function getLevel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      index = _ref.index,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  return function (rows) {
    return (0, _getParents2.default)({ index: index, idField: idField, parentField: parentField })(rows).length;
  };
};

exports.default = getLevel;